// Value formatters for the public NHSO dashboard.
//
// Every numeric field from GET /nhsoPublicDashboard may arrive as the string
// "<5" (small-cell privacy suppression). This module is the ONLY place that
// interprets that value — never parseInt/Number an API value elsewhere.
//
// - numVal(v): coerce to a number for math/bar-length ("<5" -> 0).
// - fmtVal(v): coerce to a display string (number -> th-TH grouped, "<5" as-is).
// - pctOf(part, total): integer percentage, suppression-safe.

export const numVal = v => (typeof v === "number" ? v : 0);

export const fmtVal = v =>
  typeof v === "number"
    ? v.toLocaleString("th-TH")
    : v == null
    ? "-"
    : String(v);

export const pctOf = (part, total) =>
  numVal(total) > 0 ? Math.round((numVal(part) / numVal(total)) * 100) : 0;
